$('.js-masonry').imagesLoaded( function() {
    // init Masonry after all images have loaded
    var $grid = $('.js-masonry').masonry({
        itemSelector: '.js-masonry-item',
        columnWidth: '.js-masonry-item',
        percentPosition: true,
        gutter: 0,
        initLayout: true
    });

    $('.js-masonry-item').addClass('is-active');

    window.setTimeout(function() {
        $grid.masonry('layout');
    }, 500);

    $('.js-masonry-more-button').on('click', function() {
        var $items = $('.js-masonry-more-items  .js-masonry-item');
        var $matchedItems = null;
        var count = $items.length;
        
        if (count > 20) {
            $matchedItems = $items.slice(0, 15);
        }
        else {
            $matchedItems = $items;
            $('.js-masonry-more-button').addClass('is-hidden');
        }

        $matchedItems.each(function(index, item) {
            console.log(item);

            var imageSrc = $('img', item).attr('lazy-src');
            var imageSrcset = $('img', item).attr('lazy-srcset');
            $('img', item).attr('srcset', imageSrcset);
            $('img', item).attr('src', imageSrc);
        });
        
        $grid.append($matchedItems).masonry('appended', $matchedItems);
        window.setTimeout(function() {
            $grid.masonry('layout');
        }, 500);
    });



    /* Magnific Popup */
    $('.js-lightbox-item').magnificPopup({
        type: 'image',
        midClick: true,
        image: {
            titleSrc: 'data-description'
        },
        gallery:{
            enabled:true
        },

        // Events
        callbacks: {
            change: function() {
                let title = $('.mfp-title', this.content).text();
                if (title.length === 0) {
                    $('figure', this.content).addClass('no-caption');
                }
                else {
                    $('figure', this.content).removeClass('no-caption');
                }
            }
        }
    });
});